import type { EventAttendee } from '@/features/calendarView/types';
import { User } from '@/types/user';
import { YandexUser } from '@/types/yandex';

type GetInitialUsersProps = {
  user: User | null;
  /** Id текущего пользователя в системе логов режима */
  myUserId: string | null;
  isAdmin: boolean;
  selectedUserId?: string | null;
  selectedUser?: {
    uid: string;
    display: string;
    email: string;
  } | null;
  calendarAttendees?: EventAttendee[];
  forSelfOnly?: boolean;
};

export const getInitialUsers = ({
  user,
  myUserId,
  isAdmin,
  selectedUserId,
  selectedUser,
  calendarAttendees,
  forSelfOnly,
}: GetInitialUsersProps): YandexUser[] => {
  if (!user) return [];

  if (!myUserId) return [];

  // Calendar attendees prefill (admin only)
  if (isAdmin && calendarAttendees && calendarAttendees.length > 0 && !forSelfOnly) {
    const currentUserEmail = user.email.toLowerCase();
    const result: YandexUser[] = [];
    const seen = new Set<string>();

    // Current user always first
    result.push({
      uid: myUserId,
      display: `${user.fullName} (я)`,
      email: user.email,
    });
    seen.add(currentUserEmail);

    // Add other attendees with yandexTrackerUid
    for (const attendee of calendarAttendees) {
      const emailLower = attendee.email.toLowerCase();

      if (seen.has(emailLower) || !attendee.yandexTrackerUid) continue;

      seen.add(emailLower);
      result.push({
        uid: attendee.yandexTrackerUid,
        display: attendee.displayName || attendee.email,
        email: attendee.email,
      });
    }

    return result;
  }

  const isViewingOtherUser = selectedUserId && selectedUserId !== myUserId;

  if (isAdmin && isViewingOtherUser && selectedUser) {
    // Админ просматривает другого пользователя - используем сохраненные данные
    return [
      {
        uid: selectedUser.uid,
        display: selectedUser.display,
        email: selectedUser.email,
      },
    ];
  }

  // Обычный пользователь или админ просматривает свой профиль
  return [
    {
      uid: myUserId,
      display: `${user.fullName} (я)`,
      email: user.email,
    },
  ];
};
